import React, { useState, useEffect, useRef, useMemo } from 'react';
import { FaMapMarkerAlt, FaSearch, FaTimes, FaChevronDown } from 'react-icons/fa';

// Hard-coded list of major Indian cities with coordinates
const INDIAN_CITIES = [
    { name: 'Agartala', state: 'Tripura', coordinates: '23.8315,91.2868', latitude: 23.8315, longitude: 91.2868 },
    { name: 'Agra', state: 'Uttar Pradesh', coordinates: '27.1767,78.0081', latitude: 27.1767, longitude: 78.0081 },
    { name: 'Ahmedabad', state: 'Gujarat', coordinates: '23.0225,72.5714', latitude: 23.0225, longitude: 72.5714 },
    { name: 'Aizawl', state: 'Mizoram', coordinates: '23.7271,92.7176', latitude: 23.7271, longitude: 92.7176 },
    { name: 'Ajmer', state: 'Rajasthan', coordinates: '26.4499,74.6399', latitude: 26.4499, longitude: 74.6399 },
    { name: 'Aligarh', state: 'Uttar Pradesh', coordinates: '27.8974,78.0880', latitude: 27.8974, longitude: 78.0880 },
    { name: 'Allahabad', state: 'Uttar Pradesh', coordinates: '25.4358,81.8463', latitude: 25.4358, longitude: 81.8463 },
    { name: 'Amaravati', state: 'Andhra Pradesh', coordinates: '16.5417,80.5150', latitude: 16.5417, longitude: 80.5150 },
    { name: 'Ambala', state: 'Haryana', coordinates: '30.3782,76.7767', latitude: 30.3782, longitude: 76.7767 },
    { name: 'Amritsar', state: 'Punjab', coordinates: '31.6340,74.8723', latitude: 31.6340, longitude: 74.8723 },
    { name: 'Asansol', state: 'West Bengal', coordinates: '23.6739,86.9524', latitude: 23.6739, longitude: 86.9524 },
    { name: 'Aurangabad', state: 'Maharashtra', coordinates: '19.8762,75.3433', latitude: 19.8762, longitude: 75.3433 },
    { name: 'Bareilly', state: 'Uttar Pradesh', coordinates: '28.3670,79.4304', latitude: 28.3670, longitude: 79.4304 },
    { name: 'Bangalore', state: 'Karnataka', coordinates: '12.9716,77.5946', latitude: 12.9716, longitude: 77.5946 },
    { name: 'Bardhaman', state: 'West Bengal', coordinates: '23.2324,87.8615', latitude: 23.2324, longitude: 87.8615 },
    { name: 'Belgaum', state: 'Karnataka', coordinates: '15.8497,74.4977', latitude: 15.8497, longitude: 74.4977 },
    { name: 'Bhopal', state: 'Madhya Pradesh', coordinates: '23.2599,77.4126', latitude: 23.2599, longitude: 77.4126 },
    { name: 'Bhubaneswar', state: 'Odisha', coordinates: '20.2961,85.8245', latitude: 20.2961, longitude: 85.8245 },
    { name: 'Bikaner', state: 'Rajasthan', coordinates: '28.0229,73.3119', latitude: 28.0229, longitude: 73.3119 },
    { name: 'Bilaspur', state: 'Chhattisgarh', coordinates: '22.0797,82.1391', latitude: 22.0797, longitude: 82.1391 },
    { name: 'Bokaro', state: 'Jharkhand', coordinates: '23.6693,86.1511', latitude: 23.6693, longitude: 86.1511 },
    { name: 'Chandigarh', state: 'Chandigarh', coordinates: '30.7333,76.7794', latitude: 30.7333, longitude: 76.7794 },
    { name: 'Chennai', state: 'Tamil Nadu', coordinates: '13.0827,80.2707', latitude: 13.0827, longitude: 80.2707 },
    { name: 'Coimbatore', state: 'Tamil Nadu', coordinates: '11.0168,76.9558', latitude: 11.0168, longitude: 76.9558 },
    { name: 'Cuttack', state: 'Odisha', coordinates: '20.4625,85.8828', latitude: 20.4625, longitude: 85.8828 },
    { name: 'Darbhanga', state: 'Bihar', coordinates: '26.1542,85.8918', latitude: 26.1542, longitude: 85.8918 },
    { name: 'Davanagere', state: 'Karnataka', coordinates: '14.4644,75.9218', latitude: 14.4644, longitude: 75.9218 },
    { name: 'Dehradun', state: 'Uttarakhand', coordinates: '30.3165,78.0322', latitude: 30.3165, longitude: 78.0322 },
    { name: 'Delhi', state: 'Delhi', coordinates: '28.7041,77.1025', latitude: 28.7041, longitude: 77.1025 },
    { name: 'Dhanbad', state: 'Jharkhand', coordinates: '23.7957,86.4304', latitude: 23.7957, longitude: 86.4304 },
    { name: 'Dispur', state: 'Assam', coordinates: '26.1356,91.8000', latitude: 26.1356, longitude: 91.8000 },
    { name: 'Durgapur', state: 'West Bengal', coordinates: '23.5204,87.3119', latitude: 23.5204, longitude: 87.3119 },
    { name: 'Faridabad', state: 'Haryana', coordinates: '28.4089,77.3178', latitude: 28.4089, longitude: 77.3178 },
    { name: 'Firozabad', state: 'Uttar Pradesh', coordinates: '27.1591,78.3957', latitude: 27.1591, longitude: 78.3957 },
    { name: 'Gandhinagar', state: 'Gujarat', coordinates: '23.2156,72.6369', latitude: 23.2156, longitude: 72.6369 },
    { name: 'Gaya', state: 'Bihar', coordinates: '24.7914,85.0002', latitude: 24.7914, longitude: 85.0002 },
    { name: 'Ghaziabad', state: 'Uttar Pradesh', coordinates: '28.6692,77.4538', latitude: 28.6692, longitude: 77.4538 },
    { name: 'Gorakhpur', state: 'Uttar Pradesh', coordinates: '26.7606,83.3732', latitude: 26.7606, longitude: 83.3732 },
    { name: 'Gulbarga', state: 'Karnataka', coordinates: '17.3297,76.8343', latitude: 17.3297, longitude: 76.8343 },
    { name: 'Gurgaon', state: 'Haryana', coordinates: '28.4595,77.0266', latitude: 28.4595, longitude: 77.0266 },
    { name: 'Guwahati', state: 'Assam', coordinates: '26.1445,91.7362', latitude: 26.1445, longitude: 91.7362 },
    { name: 'Gwalior', state: 'Madhya Pradesh', coordinates: '26.2183,78.1828', latitude: 26.2183, longitude: 78.1828 },
    { name: 'Hyderabad', state: 'Telangana', coordinates: '17.3850,78.4867', latitude: 17.3850, longitude: 78.4867 },
    { name: 'Imphal', state: 'Manipur', coordinates: '24.8170,93.9368', latitude: 24.8170, longitude: 93.9368 },
    { name: 'Indore', state: 'Madhya Pradesh', coordinates: '22.7196,75.8577', latitude: 22.7196, longitude: 75.8577 },
    { name: 'Itanagar', state: 'Arunachal Pradesh', coordinates: '27.0844,93.6053', latitude: 27.0844, longitude: 93.6053 },
    { name: 'Jabalpur', state: 'Madhya Pradesh', coordinates: '23.1815,79.9864', latitude: 23.1815, longitude: 79.9864 },
    { name: 'Jaipur', state: 'Rajasthan', coordinates: '26.9124,75.7873', latitude: 26.9124, longitude: 75.7873 },
    { name: 'Jalandhar', state: 'Punjab', coordinates: '31.3260,75.5762', latitude: 31.3260, longitude: 75.5762 },
    { name: 'Jammu', state: 'Jammu and Kashmir', coordinates: '32.7266,74.8570', latitude: 32.7266, longitude: 74.8570 },
    { name: 'Jamshedpur', state: 'Jharkhand', coordinates: '22.8046,86.2029', latitude: 22.8046, longitude: 86.2029 },
    { name: 'Jhansi', state: 'Uttar Pradesh', coordinates: '25.4484,78.5685', latitude: 25.4484, longitude: 78.5685 },
    { name: 'Jodhpur', state: 'Rajasthan', coordinates: '26.2389,73.0243', latitude: 26.2389, longitude: 73.0243 },
    { name: 'Kanpur', state: 'Uttar Pradesh', coordinates: '26.4499,80.3319', latitude: 26.4499, longitude: 80.3319 },
    { name: 'Kochi', state: 'Kerala', coordinates: '9.9312,76.2673', latitude: 9.9312, longitude: 76.2673 },
    { name: 'Kohima', state: 'Nagaland', coordinates: '25.6751,94.1086', latitude: 25.6751, longitude: 94.1086 },
    { name: 'Kolkata', state: 'West Bengal', coordinates: '22.5726,88.3639', latitude: 22.5726, longitude: 88.3639 },
    { name: 'Kota', state: 'Rajasthan', coordinates: '25.2138,75.8648', latitude: 25.2138, longitude: 75.8648 },
    { name: 'Lucknow', state: 'Uttar Pradesh', coordinates: '26.8467,80.9462', latitude: 26.8467, longitude: 80.9462 },
    { name: 'Ludhiana', state: 'Punjab', coordinates: '30.9010,75.8573', latitude: 30.9010, longitude: 75.8573 },
    { name: 'Madurai', state: 'Tamil Nadu', coordinates: '9.9252,78.1198', latitude: 9.9252, longitude: 78.1198 },
    { name: 'Mangalore', state: 'Karnataka', coordinates: '12.9141,74.8560', latitude: 12.9141, longitude: 74.8560 },
    { name: 'Meerut', state: 'Uttar Pradesh', coordinates: '28.9845,77.7064', latitude: 28.9845, longitude: 77.7064 },
    { name: 'Mumbai', state: 'Maharashtra', coordinates: '19.0760,72.8777', latitude: 19.0760, longitude: 72.8777 },
    { name: 'Muzaffarpur', state: 'Bihar', coordinates: '26.1209,85.3647', latitude: 26.1209, longitude: 85.3647 },
    { name: 'Mysore', state: 'Karnataka', coordinates: '12.2958,76.6394', latitude: 12.2958, longitude: 76.6394 },
    { name: 'Nagpur', state: 'Maharashtra', coordinates: '21.1458,79.0882', latitude: 21.1458, longitude: 79.0882 },
    { name: 'Nainital', state: 'Uttarakhand', coordinates: '29.3919,79.4542', latitude: 29.3919, longitude: 79.4542 },
    { name: 'Nashik', state: 'Maharashtra', coordinates: '19.9975,73.7898', latitude: 19.9975, longitude: 73.7898 },
    { name: 'New Delhi', state: 'Delhi', coordinates: '28.6139,77.2090', latitude: 28.6139, longitude: 77.2090 },
    { name: 'Noida', state: 'Uttar Pradesh', coordinates: '28.5355,77.3910', latitude: 28.5355, longitude: 77.3910 },
    { name: 'Panaji', state: 'Goa', coordinates: '15.4909,73.8278', latitude: 15.4909, longitude: 73.8278 },
    { name: 'Patiala', state: 'Punjab', coordinates: '30.3398,76.3869', latitude: 30.3398, longitude: 76.3869 },
    { name: 'Patna', state: 'Bihar', coordinates: '25.5941,85.1376', latitude: 25.5941, longitude: 85.1376 },
    { name: 'Puducherry', state: 'Puducherry', coordinates: '11.9416,79.8083', latitude: 11.9416, longitude: 79.8083 },
    { name: 'Pune', state: 'Maharashtra', coordinates: '18.5204,73.8567', latitude: 18.5204, longitude: 73.8567 },
    { name: 'Raipur', state: 'Chhattisgarh', coordinates: '21.2514,81.6296', latitude: 21.2514, longitude: 81.6296 },
    { name: 'Rajkot', state: 'Gujarat', coordinates: '22.3039,70.8022', latitude: 22.3039, longitude: 70.8022 },
    { name: 'Ranchi', state: 'Jharkhand', coordinates: '23.3441,85.3096', latitude: 23.3441, longitude: 85.3096 },
    { name: 'Shillong', state: 'Meghalaya', coordinates: '25.5788,91.8933', latitude: 25.5788, longitude: 91.8933 },
    { name: 'Shimla', state: 'Himachal Pradesh', coordinates: '31.1048,77.1734', latitude: 31.1048, longitude: 77.1734 },
    { name: 'Silchar', state: 'Assam', coordinates: '24.8333,92.7789', latitude: 24.8333, longitude: 92.7789 },
    { name: 'Siliguri', state: 'West Bengal', coordinates: '26.7271,88.3953', latitude: 26.7271, longitude: 88.3953 },
    { name: 'Srinagar', state: 'Jammu and Kashmir', coordinates: '34.0837,74.7973', latitude: 34.0837, longitude: 74.7973 },
    { name: 'Surat', state: 'Gujarat', coordinates: '21.1702,72.8311', latitude: 21.1702, longitude: 72.8311 },
    { name: 'Thane', state: 'Maharashtra', coordinates: '19.2183,72.9781', latitude: 19.2183, longitude: 72.9781 },
    { name: 'Thiruvananthapuram', state: 'Kerala', coordinates: '8.5241,76.9366', latitude: 8.5241, longitude: 76.9366 },
    { name: 'Thrissur', state: 'Kerala', coordinates: '10.5276,76.2144', latitude: 10.5276, longitude: 76.2144 },
    { name: 'Tiruchirappalli', state: 'Tamil Nadu', coordinates: '10.7905,78.7047', latitude: 10.7905, longitude: 78.7047 },
    { name: 'Udaipur', state: 'Rajasthan', coordinates: '24.5854,73.7125', latitude: 24.5854, longitude: 73.7125 },
    { name: 'Vadodara', state: 'Gujarat', coordinates: '22.3072,73.1812', latitude: 22.3072, longitude: 73.1812 },
    { name: 'Varanasi', state: 'Uttar Pradesh', coordinates: '25.3176,82.9739', latitude: 25.3176, longitude: 82.9739 },
    { name: 'Vijayawada', state: 'Andhra Pradesh', coordinates: '16.5062,80.6480', latitude: 16.5062, longitude: 80.6480 },
    { name: 'Visakhapatnam', state: 'Andhra Pradesh', coordinates: '17.6868,83.2185', latitude: 17.6868, longitude: 83.2185 },
    { name: 'Warangal', state: 'Telangana', coordinates: '17.9784,79.5941', latitude: 17.9784, longitude: 79.5941 },
    { name: 'Yamunanagar', state: 'Haryana', coordinates: '30.1290,77.2674', latitude: 30.1290, longitude: 77.2674 },
  
    // Extra important cities not yet added
    { name: 'Alappuzha', state: 'Kerala', coordinates: '9.4981,76.3388', latitude: 9.4981, longitude: 76.3388 },
    { name: 'Anantapur', state: 'Andhra Pradesh', coordinates: '14.6819,77.6006', latitude: 14.6819, longitude: 77.6006 },
    { name: 'Balasore', state: 'Odisha', coordinates: '21.4934,86.9330', latitude: 21.4934, longitude: 86.9330 },
    { name: 'Ballari', state: 'Karnataka', coordinates: '15.1394,76.9214', latitude: 15.1394, longitude: 76.9214 },
    { name: 'Bhagalpur', state: 'Bihar', coordinates: '25.2425,86.9856', latitude: 25.2425, longitude: 86.9856 },
    { name: 'Bhavnagar', state: 'Gujarat', coordinates: '21.7645,72.1519', latitude: 21.7645, longitude: 72.1519 },
    { name: 'Bhiwani', state: 'Haryana', coordinates: '28.7990,76.1330', latitude: 28.7990, longitude: 76.1330 },
    { name: 'Chittoor', state: 'Andhra Pradesh', coordinates: '13.2172,79.1003', latitude: 13.2172, longitude: 79.1003 },
    { name: 'Dibrugarh', state: 'Assam', coordinates: '27.4728,94.9110', latitude: 27.4728, longitude: 94.9110 },
    { name: 'Erode', state: 'Tamil Nadu', coordinates: '11.3410,77.7172', latitude: 11.3410, longitude: 77.7172 },
    { name: 'Guntur', state: 'Andhra Pradesh', coordinates: '16.3067,80.4365', latitude: 16.3067, longitude: 80.4365 },
    { name: 'Haldwani', state: 'Uttarakhand', coordinates: '29.2183,79.5126', latitude: 29.2183, longitude: 79.5126 },
    { name: 'Haridwar', state: 'Uttarakhand', coordinates: '29.9457,78.1642', latitude: 29.9457, longitude: 78.1642 },
    { name: 'Hisar', state: 'Haryana', coordinates: '29.1492,75.7217', latitude: 29.1492, longitude: 75.7217 },
    { name: 'Jalgaon', state: 'Maharashtra', coordinates: '21.0077,75.5626', latitude: 21.0077, longitude: 75.5626 },
    { name: 'Junagadh', state: 'Gujarat', coordinates: '21.5222,70.4579', latitude: 21.5222, longitude: 70.4579 },
    { name: 'Kakinada', state: 'Andhra Pradesh', coordinates: '16.9891,82.2475', latitude: 16.9891, longitude: 82.2475 },
    { name: 'Kalyan', state: 'Maharashtra', coordinates: '19.2403,73.1305', latitude: 19.2403, longitude: 73.1305 },
    { name: 'Karimnagar', state: 'Telangana', coordinates: '18.4386,79.1288', latitude: 18.4386, longitude: 79.1288 },
    { name: 'Kollam', state: 'Kerala', coordinates: '8.8932,76.6141', latitude: 8.8932, longitude: 76.6141 },
    { name: 'Kurnool', state: 'Andhra Pradesh', coordinates: '15.8281,78.0373', latitude: 15.8281, longitude: 78.0373 },
    { name: 'Mathura', state: 'Uttar Pradesh', coordinates: '27.4924,77.6737', latitude: 27.4924, longitude: 77.6737 },
    { name: 'Moradabad', state: 'Uttar Pradesh', coordinates: '28.8386,78.7733', latitude: 28.8386, longitude: 78.7733 },
    { name: 'Muzaffarnagar', state: 'Uttar Pradesh', coordinates: '29.4730,77.7041', latitude: 29.4730, longitude: 77.7041 },
    { name: 'Nanded', state: 'Maharashtra', coordinates: '19.1383,77.3210', latitude: 19.1383, longitude: 77.3210 },
    { name: 'Navsari', state: 'Gujarat', coordinates: '20.9467,72.9520', latitude: 20.9467, longitude: 72.9520 },
    { name: 'Palakkad', state: 'Kerala', coordinates: '10.7867,76.6548', latitude: 10.7867, longitude: 76.6548 },
    { name: 'Pali', state: 'Rajasthan', coordinates: '25.7725,73.3234', latitude: 25.7725, longitude: 73.3234 },
    { name: 'Rewa', state: 'Madhya Pradesh', coordinates: '24.5346,81.2923', latitude: 24.5346, longitude: 81.2923 },
    { name: 'Rohtak', state: 'Haryana', coordinates: '28.8955,76.6066', latitude: 28.8955, longitude: 76.6066 },
    { name: 'Rourkela', state: 'Odisha', coordinates: '22.2604,84.8536', latitude: 22.2604, longitude: 84.8536 },
    { name: 'Saharanpur', state: 'Uttar Pradesh', coordinates: '29.9640,77.5460', latitude: 29.9640, longitude: 77.5460 },
    { name: 'Salem', state: 'Tamil Nadu', coordinates: '11.6643,78.1460', latitude: 11.6643, longitude: 78.1460 },
    { name: 'Satna', state: 'Madhya Pradesh', coordinates: '24.5773,80.8322', latitude: 24.5773, longitude: 80.8322 },
    { name: 'Secunderabad', state: 'Telangana', coordinates: '17.4399,78.4983', latitude: 17.4399, longitude: 78.4983 },
    { name: 'Solapur', state: 'Maharashtra', coordinates: '17.6599,75.9064', latitude: 17.6599, longitude: 75.9064 },
    { name: 'Sonipat', state: 'Haryana', coordinates: '28.9931,77.0151', latitude: 28.9931, longitude: 77.0151 },
    { name: 'Tirunelveli', state: 'Tamil Nadu', coordinates: '8.7139,77.7567', latitude: 8.7139, longitude: 77.7567 },
    { name: 'Tirupati', state: 'Andhra Pradesh', coordinates: '13.6288,79.4192', latitude: 13.6288, longitude: 79.4192 },
    { name: 'Tumakuru', state: 'Karnataka', coordinates: '13.3409,77.1010', latitude: 13.3409, longitude: 77.1010 },
    { name: 'Ujjain', state: 'Madhya Pradesh', coordinates: '23.1765,75.7885', latitude: 23.1765, longitude: 75.7885 },
    { name: 'Vellore', state: 'Tamil Nadu', coordinates: '12.9165,79.1325', latitude: 12.9165, longitude: 79.1325 },
    { name: 'Arrah', state: 'Bihar', coordinates: '25.5560,84.6630', latitude: 25.5560, longitude: 84.6630 },
    { name: 'Begusarai', state: 'Bihar', coordinates: '25.4185,86.1336', latitude: 25.4185, longitude: 86.1336 },
    { name: 'Bettiah', state: 'Bihar', coordinates: '26.8023,84.5020', latitude: 26.8023, longitude: 84.5020 },
    { name: 'Buxar', state: 'Bihar', coordinates: '25.5647,83.9777', latitude: 25.5647, longitude: 83.9777 },
    { name: 'Chapra', state: 'Bihar', coordinates: '25.7803,84.7476', latitude: 25.7803, longitude: 84.7476 },
    { name: 'Darbhanga', state: 'Bihar', coordinates: '26.1542,85.8918', latitude: 26.1542, longitude: 85.8918 },
    { name: 'Dehri', state: 'Bihar', coordinates: '24.9050,84.1866', latitude: 24.9050, longitude: 84.1866 },
    { name: 'Katihar', state: 'Bihar', coordinates: '25.5385,87.5705', latitude: 25.5385, longitude: 87.5705 },
    { name: 'Kishanganj', state: 'Bihar', coordinates: '26.1020,87.9412', latitude: 26.1020, longitude: 87.9412 },
    { name: 'Madhubani', state: 'Bihar', coordinates: '26.3610,86.0717', latitude: 26.3610, longitude: 86.0717 },
    { name: 'Motihari', state: 'Bihar', coordinates: '26.6486,84.9166', latitude: 26.6486, longitude: 84.9166 },
    { name: 'Munger', state: 'Bihar', coordinates: '25.3746,86.4735', latitude: 25.3746, longitude: 86.4735 },
    { name: 'Nawada', state: 'Bihar', coordinates: '24.8867,85.5383', latitude: 24.8867, longitude: 85.5383 },
    { name: 'Purnia', state: 'Bihar', coordinates: '25.7771,87.4753', latitude: 25.7771, longitude: 87.4753 },
    { name: 'Saharsa', state: 'Bihar', coordinates: '25.8835,86.6005', latitude: 25.8835, longitude: 86.6005 },
    { name: 'Samastipur', state: 'Bihar', coordinates: '25.8616,85.7810', latitude: 25.8616, longitude: 85.7810 },
    { name: 'Sasaram', state: 'Bihar', coordinates: '24.9520,84.0280', latitude: 24.9520, longitude: 84.0280 },
    { name: 'Sitamarhi', state: 'Bihar', coordinates: '26.5953,85.4906', latitude: 26.5953, longitude: 85.4906 },
    { name: 'Siwan', state: 'Bihar', coordinates: '26.2196,84.3561', latitude: 26.2196, longitude: 84.3561 },
    { name: 'Supaul', state: 'Bihar', coordinates: '26.1164,86.6050', latitude: 26.1164, longitude: 86.6050 }
      

  ];
  

const HardcodedLocationSelector = ({
  value = '',
  onChange,
  placeholder = "Search for a city...",
  className = "",
  disabled = false,
  onLocationSelect = null
}) => {
  const [searchQuery, setSearchQuery] = useState(value);
  const [filteredCities, setFilteredCities] = useState(INDIAN_CITIES);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState(null);
  
  const inputRef = useRef(null);
  const dropdownRef = useRef(null);

  // Sort cities alphabetically by name using useMemo to avoid recreating on every render
  const sortedCities = useMemo(() => 
    [...INDIAN_CITIES].sort((a, b) => a.name.localeCompare(b.name)), 
    []
  );

  // Filter cities based on search query
  useEffect(() => {
    if (searchQuery.trim() === '') {
      setFilteredCities(sortedCities);
    } else {
      const filtered = sortedCities.filter(city => 
        city.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
        city.state.toLowerCase().includes(searchQuery.toLowerCase())
      );
      setFilteredCities(filtered);
    }
  }, [searchQuery, sortedCities]);

  // Handle input change
  const handleInputChange = (e) => {
    const query = e.target.value;
    setSearchQuery(query);
    setIsOpen(true);
  };

  // Handle city selection
  const handleCitySelect = (city) => {
    const locationData = {
      name: city.name,
      address: `${city.name}, ${city.state}, India`,
      coordinates: city.coordinates,
      latitude: city.latitude,
      longitude: city.longitude,
      placeId: null
    };
    
    setSearchQuery(city.name);
    setSelectedLocation(locationData);
    setIsOpen(false);
    
    // Call onChange with location details
    if (onChange) {
      onChange(locationData);
    }

    // Call onLocationSelect if provided
    if (onLocationSelect) {
      onLocationSelect(locationData);
    }
  };

  // Handle input focus
  const handleFocus = () => {
    setIsOpen(true);
  };

  // Handle input blur with delay to allow click on dropdown
  const handleBlur = () => {
    setTimeout(() => {
      setIsOpen(false);
    }, 200);
  };

  // Clear selection
  const handleClear = () => {
    setSearchQuery('');
    setSelectedLocation(null);
    setIsOpen(false);
    if (onChange) {
      onChange(null);
    }
    if (onLocationSelect) {
      onLocationSelect(null);
    }
    inputRef.current?.focus();
  };

  // Handle keyboard navigation
  const handleKeyDown = (e) => {
    if (e.key === 'Escape') {
      setIsOpen(false);
      inputRef.current?.blur();
    }
  };

  return (
    <div className={`relative ${className}`}>
      {/* Search Input */}
      <div className="relative">
        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
          <FaSearch className="h-4 w-4 text-gray-400" />
        </div>
        <input
          ref={inputRef}
          type="text"
          value={searchQuery}
          onChange={handleInputChange}
          onFocus={handleFocus}
          onBlur={handleBlur}
          onKeyDown={handleKeyDown}
          placeholder={placeholder}
          disabled={disabled}
          className="w-full pl-10 pr-10 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500 disabled:bg-gray-100 disabled:cursor-not-allowed"
        />
        {searchQuery && (
          <button
            onClick={handleClear}
            className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-gray-600"
          >
            <FaTimes className="h-4 w-4" />
          </button>
        )}
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-gray-600"
        >
          <FaChevronDown className={`h-4 w-4 transition-transform ${isOpen ? 'rotate-180' : ''}`} />
        </button>
      </div>

      {/* Dropdown */}
      {isOpen && (
        <div
          ref={dropdownRef}
          className="absolute z-50 w-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg max-h-60 overflow-y-auto"
        >
          {filteredCities.length > 0 ? (
            <div className="py-1">
              {filteredCities.map((city, index) => (
                <button
                  key={`${city.name}-${index}`}
                  onClick={() => handleCitySelect(city)}
                  className="w-full px-4 py-3 text-left hover:bg-orange-50 focus:bg-orange-50 focus:outline-none flex items-center"
                >
                  <FaMapMarkerAlt className="h-4 w-4 text-orange-500 mr-3 flex-shrink-0" />
                  <div className="flex-1 min-w-0">
                    <div className="text-sm font-medium text-gray-900 truncate">
                      {city.name}
                    </div>
                    <div className="text-xs text-gray-500 truncate">
                      {city.state}, India
                    </div>
                  </div>
                </button>
              ))}
            </div>
          ) : (
            <div className="px-4 py-3 text-sm text-gray-500 text-center">
              No cities found matching "{searchQuery}"
            </div>
          )}
        </div>
      )}

      {/* Selected Location Display */}
      {selectedLocation && (
        <div className="mt-2 p-3 bg-orange-50 border border-orange-200 rounded-lg">
          <div className="flex items-center">
            <FaMapMarkerAlt className="h-4 w-4 text-orange-500 mr-2" />
            <div>
              <div className="text-sm font-medium text-gray-900">
                {selectedLocation.name}
              </div>
              <div className="text-xs text-gray-600">
                {selectedLocation.address}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default HardcodedLocationSelector;
